<div class="hidden md-flex sa-mobile-nav">
  <div class="sa-mobile-nav-content flex">
    <div class="sa-mobile-nav-icon">
      <sa-icon img="/assets/saras_blue.svg" imgWidth="58" imgHeight="32" hrefTarget="blank" href="https://www.sarasanalytics.com/"></sa-icon>
    </div>
    <div class="sa-mobile-nav-logout" (click)="mobileLogoutClick($event)">
      <sa-avatar size="medium" [altText]="this.avatarNavItem.altText || ''"></sa-avatar>
    </div>
  </div>
</div>
<sa-left-nav [config]="data" (clickEvent)="leftNavEvent($event)" #leftnavTemp>
  <router-outlet></router-outlet>
</sa-left-nav>

<ng-template #logoutButton>
  <div class="sa-logout md-hidden" (click)="logoutButtonClick()">
    <span>Logout</span>
  </div>
  <div class="hidden md-flex sa-profile-popover flex-col">
    <div class="sa-profile-header">
      <div class="sa-profile-name">{{ user?.firstName }} {{ user?.lastName }}</div>
      <div class="sa-profile-email">{{ user?.email }}</div>
    </div>
    <div class="sa-profile-divider"></div>
    <div class="sa-profile-action flex" (click)="logoutButtonClick()">
      <sa-icon icon="logout" size="20"></sa-icon>
      <span class="sa-profile-action-text">Logout</span>
    </div>
  </div>
</ng-template>

@if(toast){
<div class="sa-toast-content">
  <!-- <sa-toast class="block" [subHeading]="toast.subHeading || ''" [status]="toast.status || 'success'"
    [statusIcon]="toast.statusIcon || ''" width="424px" [finishPercentage]=40 [closable]="true"></sa-toast> -->
  <!-- <sa-toast [statusIcon]="'../assets/checkCircleFilledGreen'" width="456px" [heading]="'MFA setup is successful'"
    [closable]="true" [finishPercentage]="toast.finishPercentage || 0"></sa-toast> -->
  <sa-toast [statusIcon]="toast.statusIcon || '../assets/checkCircleFilledGreen'" [width]="toast.width|| '456px'"
    [heading]="toast.heading || 'MFA setup is successful'" [closable]="true"
    [finishPercentage]="toast.finishPercentage || 0" [toastIconSize]="'32'" [toastCloseIconSize]="'24'"
    [toastCloseIcon]="'../assets/closeOutlined'" (toastEvent)="onToastEvents($event)"></sa-toast>
</div>
}